﻿import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { CompanyDto } from 'src/app/dtos/company-dto';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { PlantDto } from 'src/app/dtos/plant-dto';

@Component({
    selector: 'plants',
    templateUrl: './plants.component.html',
    styleUrls: ['./plants.component.scss']
})

export class PlantsComponent {
    
    search: any;
    @ViewChild("tableChild") tableChild: DataTableComponent<PlantDto>;
  pagePath: string = "api/plant/page";
  searchText: string = '';
  options = {
    columnTitles: ["PLANT.TABLE.ID", "PLANT.TABLE.NAME" , "PLANT.TABLE.COMPANY", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'name', 'companyName', "actions"],
    actionButtons: { edit: true, delete: true }
  };

    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

    goToEdit(e: any) {
      this.router.navigate(["plants/edit", e.id]);
    }

    openDeleteDialog(e: any) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '680px',
        data: {
          title: 'DIALOGS.DELETE_PLANT.TITLE',
          body: 'DIALOGS.DELETE_PLANT.BODY',
          cancelButtonText: "GENERAL.LABELS.CANCEL",
          confirmButtonText: "GENERAL.LABELS.DELETE",
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.apiService.delete('api/plant/' + e.id).subscribe(data => {
            this.messageService.success("USERS.MESSAGES.SUCCESS", "PLANT.MESSAGES.REMOVED");
            this.tableChild.loadPage();
          }, error => {
            this.messageService.error("Error", error.message);
          })
        }
      });
    }

  searchPant(){
      this.search = {
          searchText: this.searchText
        }
        this.tableChild.firstPage();
        this.tableChild.loadPage(this.search);
  }
}